import { PermissionRequestPage } from './../permission-request/permission-request';
import { ToastProvider } from './../../providers/toast';
import { LoadingProvider } from './../../providers/loading';
import { DeveloperProvider } from './../../providers/developers';
import { UserModel } from './../../models/userModel';
import { AdminUsersDetailPage } from './../admin-users-detail/admin-users-detail';
import { Component } from '@angular/core';
import { NavController, NavParams, IonicPage, Events } from 'ionic-angular';
import { GlobalVariables } from "../../variables/global";
import { CustomErrorHandler } from "@questrade/flx-commons";

export interface FilterParams {
  username: string,
  merchant: string,
  status: string,
  usersPages: number,
  clientId: string
}

@IonicPage({
  name: 'admin-users'
})
@Component({
  selector: 'page-admin-users',
  templateUrl: 'admin-users.html',
})

export class AdminUsersPage {
  private users: Array<UserModel>;
  private admin: string;
  private activePage: number = 1;
  private numberOfPages: number;
  private pageSize: number = 10;
  private filterParams: FilterParams;
  private developers;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private devProvider: DeveloperProvider,
    private loading: LoadingProvider,
    private toast: ToastProvider,
    private events: Events,
    private customErrorHandler: CustomErrorHandler) {
    this.events.publish('menu:changed', true, 'User account');
    this.initializeFilter();
    this.callProvider();
  }


  callProvider() {
    this.devProvider.getUsers(this.filterParams.usersPages)
      .subscribe(data => {
        this.users = data.developers.developers;
        this.setPagination(data.developers);
        this.admin = GlobalVariables.username;
        this.developers = data.developers;
      }, error => {
        this.customErrorHandler.handleError(error.json());
      });
  }

  initializeFilter() {
    this.filterParams = {
      username: '',
      merchant: '',
      status: 'any',
      usersPages: 1,
      clientId: ''
    }
  }

  initializeItems() {
    let usersInfo = this.developers;
    this.users = usersInfo.developers;
    this.numberOfPages = Math.floor(usersInfo.totalUsers / this.pageSize) + 1;
    this.admin = GlobalVariables.username;
  }

  goDetailPage(username: string) {
    let loadingInstance = this.loading.create();
    this.devProvider.getUserByAdmin(username)
      .subscribe(data => {
        this.navCtrl.push(AdminUsersDetailPage, { userDetail: data, offerPlans: [] })
        loadingInstance.dismiss();

      }, error => {
        this.customErrorHandler.handleError(error.json());
        loadingInstance.dismiss();
      })
  }

  addUser() {
    this.navCtrl.push(PermissionRequestPage, { isAdmin: true });
  }

  filterUsers(fromPagination?) {
    if (!fromPagination) {
      this.filterParams.usersPages = 1;
      this.activePage = 1;
    }
    this.devProvider.filterUsers(this.filterParams)
      .debounceTime(1000)
      .subscribe(
        data => {
          this.users = data.developers.developers;
          this.setPagination(data.developers);
        },
        error => {
          this.customErrorHandler.handleError(error.json());
        }
      )
  }

  setPagination(developers) {
    if (developers.totalUsers && developers.totalUsers > 0) {
      this.numberOfPages = Math.floor(developers.totalUsers / this.pageSize);
      if ((developers.totalUsers % this.pageSize) > 0) {
        this.numberOfPages += 1;
      }
    } else {
      this.numberOfPages = 0;
    }
  }

  changePage(action: string) {
    this.activePage = action === 'next' ? this.activePage + 1 : this.activePage - 1
    this.filterParams.usersPages = this.activePage;
    const fromPagination = true;
    this.filterUsers(fromPagination);
  }
}



// WEBPACK FOOTER //
// ./src/pages/admin-users/admin-users.ts